import { fetchAction, fetchActionPost } from "../../../helpers/fetch";

// Fetch heatmap tags
export const fetchHeatmapTags = () => fetchAction('/api/heatmap/tags', [
    'FETCH_HEATMAP_TAGS_REQUEST',
    'FETCH_HEATMAP_TAGS_SUCCESS',
    'FETCH_HEATMAP_TAGS_FAILURE'
]);

// Action creators
export const setHeatmapTags = (tags) => ({
    type: 'SET_HEATMAP_TAGS',
    payload: tags
});

export const fetchHeatmap = () => fetchAction('/api/heatmap/data-v1', [
    'FETCH_HEATMAP_REQUEST',
    'FETCH_HEATMAP_SUCCESS',
    'FETCH_HEATMAP_FAILURE'
]);

export const fetchCreationsByTags = (tags) => fetchActionPost('/api/heatmap/creations-by-tags', { tags }, [
    'FETCH_CREATIONS_BY_TAGS_REQUEST',
    'FETCH_CREATIONS_BY_TAGS_SUCCESS',
    'FETCH_CREATIONS_BY_TAGS_FAILURE'
]);